import React, { useState, useEffect, useRef, lazy, Suspense } from 'react';
import Main from "./Main/Main";
import ProductConfigurator from './ProductConfigurator/ProductConfigurator';
import { Spinner } from 'spin.js';
import { checkLicense } from '../components/LicenseManager/checkLicense';

//const Main = lazy(() => import('./Main/Main'));

//Previous implementation: "customerBucketName" : "exampleclient"
//TODO: Create custom cloudfront url
const defaultModelViewerData = {
  customerBucketName: "growmexampleclient",
  cloudFrontUrl: "https://d1kemlkva5bpmc.cloudfront.net",
  // productSKU : "GS-SS3-01",
  // productSKU : "ZN-M8H-01",
  //productSKU : "SC-PKG-01",
   productSKU : "ZN-M6S-01-test",
  //productSKU : "ZN-M6S-02",
  //productSKU : "ZN-M6S-03",
  // productSKU: "SH-AAV-01",
  // productSKU: "WC-RTT-01",
  //productSKU: "BA-DDB-01",
  // productSKU: "RF-LB1-01",
  // productSKU: "RF-MR-01",
  //productSKU: "RFT-RM-NR1",
  //productSKU: "RFT-ALC-PCASE-40x80",
  // productSKU: "SC-HDC-01",
  //  productSKU : "ZN-N2H-01",
  //productSKU : "ZN-ABC-01",
  // productSKU : "HF-B3S-01",
  //productTags: [],
  productTags: [],
  // "smallObject"
  productSettings: {
    "ThreeSixtyViewer": 1,
    "Lifestyle": 3,
    "ModelViewer": 2,
    "orientation": "horizontal",
    "showDimensions": true,
    "simpleDimensions": false,
    "sceneBackgroundColour": "white",
    "isAREnabled": true,
    "qrCode": true,
    "showRotationIconOnStartup": true,
    "windowMargin": 40,
    "react360ImagesCount": 36,
    "is180Pan": false,
    "enableConfigurator": false,
    "growm360autoplaySpeed": 15,
    //"isBaked": false,
    "constantScale": false,
    "switchToFullScreen": 1175,
    "arrowColour": "red",
    "buttonsMargin": 16,
    "viewerMarginLeft": 30,
    "viewerMarginRight": 0,
    "viewerMarginBottom": 10,
    "viewerContainerMarginLeft": 0,
    "viewerContainerMarginRight": 0,
    "viewerContainerMarginBottom": 30,
    "modelViewerMargin": 0,
    "additionalButtonsMaxSize": 200,
    "showDimensionsAtStart": false,
    "reversableAnimation": true,
    "multiModels": true,
    "showProductButtons": true,
    "pure3D": true,
    "ThreeSixtyViewToggle": true,
    "tiltAngle": 48,
    "panAngle": 75,
    "startCamYawAngle": -125,
    "startCamPitchAngle": 75,
    "numDigits": 0,
    "units": "mm",
    "buttonShadowColour": "#00137a",
    "environmentIntensity": 0.7,
    //"dimLineColour": "red",
    "labelColour": "#555555",
    "maxZoomFactor": 2,
    "zoomClose": 0.3,
    "meshInteractions": true,
    "fullAngle": true,
    "animButtonTooltip": "Exploded View",
    "animButtonTooltip2": "Open Clasp",
    // "interactiveMeshes": ["mechanism1", "mechanism2"],
    "animationMapping": {
      "mechanism1": "OpenClose",
      "mechanism2": "OpenClose"
    }
  }
  // ,
  // dimensionsJson: {
  //   "modelSetup": {
  //     "units": "mm",
  //     "Screw Head Type": "Hex Head"
  //   },
  //   "Screw Gauge": "15",
  //   "Screw Length": "25"
  // }
  ,
  assetsUrls: {
  //   "imagesSpin": [
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/1.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/2.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/3.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/4.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/5.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/6.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/7.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/8.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/9.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/10.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/11.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/12.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/13.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/14.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/15.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/16.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/17.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/18.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/19.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/20.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/21.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/22.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/23.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/24.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/25.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/26.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/27.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/28.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/29.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/30.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/31.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/32.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/33.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/34.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/35.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/36.jpg"
  //   ],
  //   "imagesSpinFull": [
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/1_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/2_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/3_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/4_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/5_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/6_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/7_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/8_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/9_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/10_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/11_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/12_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/13_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/14_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/15_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/16_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/17_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/18_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/19_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/20_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/21_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/22_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/23_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/24_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/25_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/26_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/27_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/28_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/29_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/30_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/31_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/32_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/33_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/34_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/35_full.jpg", 
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/36_full.jpg"
  //   ],
  //   "imagesSpinThumb": [
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/thumbnail_back.jpg",
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/thumbnail_front.jpg",
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/thumbnail_left.jpg",
  //     // "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/thumbnail_right.jpg"
  // ],
    // "productImages": [
    //   "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/screw1a_1.jpeg",
    //   "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/screw_2.jpg",
    //   "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/screw_3.jpg",
    //   "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/screw_4.jpg"
    // ],
    //"modelGlb": "https://d1kemlkva5bpmc.cloudfront.net/GS-SS3-01/home_furniture_sofa_signature.glb ",
    "modelGlb": "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01-test/zuludiver_octopod_polished.glb",
  //   //"modelGlbU": "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/Screw1a_uncompressed.glb",
  //   //"modelUsd": "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/Screw1a.usd",
  //   //"modelHdrs": "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01/Screw1a.hdrs",
      "environmentHdrs": "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01-test/geckota_studio_env.hdr",
    // "configJson": "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01-test/config.json",
  //   // "dimensionsJson": "https://d1kemlkva5bpmc.cloudfront.net/ZN-M6S-01-test/dimensions.json"
  }
};

//TODO: Implement spin images and spin thumb images

const databaseType = {
  shopify: "shopify",
  wooCommerce: "woocommerce",
  test: "test",
};

//TODO: Look at using json to set more attributes. Could be done on the php side and still passed as attributes here
//Downside is that you'd need to implement that same code on every website. Downside of reading json from react is that it takes time
//Passing the json directly here as an argument would be good. 
//Only pass website wide parameters in that file as we need to load variants correctly
const ProductViewer = ({ showAdditionalButtons, rootDiv }) => {
  useEffect(() => {
    console.log('customer bucket name: ', customerBucketName);
    console.log('cloudfront url: ', cloudFrontUrl);
    console.log('productSKU: ', productSKU);
    console.log('product tags:', productTags);
    console.log('window asset URL:', window.ASSET_BASE_URL);
    console.log('Show product buttons:', showProductButtons);
  }, []); // Empty dependency array means this only runs on initial mount

  //TODO: Add parameters to productSettings: black background, sizing for small objects + divide dimensions, AR. 
  //If value is below zero, don't show that element as first element, i.e. rule out if < 0
  //Need to parse the whole bucket and instantiate app each time, using props here, where you get the productFolder from each time
  const [loading, setLoading] = useState(true);
  const [customerBucketName, setCustomerBucketName] = useState(document.getElementById(rootDiv).getAttribute('data-customer-bucket-name'));
  const [cloudFrontUrl, setCloudFrontUrl] = useState(document.getElementById(rootDiv).getAttribute('data-cloudfront-url'));
  const [productSKU, setProductSKU] = useState(document.getElementById(rootDiv).getAttribute('data-product-sku'));
  const [showProductButtons, setShowProductButtons] = useState(document.getElementById(rootDiv).getAttribute('data-showproduct-buttons'));
  const [productVariants, setProductVariants] = useState([]);
  const [productVariantsAttrTest, setProductVariantsAttrTest] = useState([]);
  const [productVariantsTest, setProductVariantsTest] = useState([]);
  const [productTags, setProductTags] = useState(() => {
    const tagsString = document.getElementById(rootDiv).getAttribute('data-product-tags');
    try {
      return tagsString ? JSON.parse(tagsString) : defaultModelViewerData.productTags;
    } catch (error) {
      console.error("Error parsing product tags:", error);
      return defaultModelViewerData.productTags;
    }
  });
  const [productSettings, setProductSettings] = useState(document.getElementById(rootDiv).getAttribute('data-product-settings'));
  const [dimensionsJson, setDimensionsJson] = useState(document.getElementById(rootDiv).getAttribute('data-dimensions-json'));
  const [assetsUrls, setAssetsUrls] = useState(JSON.parse(document.getElementById(rootDiv).getAttribute('data-assets-urls')));
  const [isAutoPlay, setIsAutoplay] = useState(true);
  const [isConfiguratorEnabled, setIsConfiguratorEnabled] = useState(false);
  const [enableConfigurator, setEnableConfigurator] = useState(false);
  const [meshClicked, setMeshClicked] = useState(null);
  const spinnerContainerRef = useRef(null); // Create a reference for the spinner container
  const spinnerInstanceRef = useRef(null); // Store the Spinner instance
  const [variantFoldersNames, setVariantFoldersNames] = useState();
  const [isLicenseValid, setIsLicenseValid] = useState(true);

  const toggleConfigurator = () => {
    console.log('toggle configurator, isConfigurator:', isConfiguratorEnabled);
    setIsConfiguratorEnabled((prev) => !prev);
  }

  const onMeshClicked = (mesh) => {
    console.log('Mesh clicked:', mesh);
    setMeshClicked({ id: Date.now(), name: mesh });
    //setMeshClicked(mesh);
  }

  useEffect(() => {
    let isMounted = true;

    //setIsLicenseValid(true);

    (async () => {
      const valid = await checkLicense();
      if (isMounted) {
        if (!valid) {
          console.error("Invalid license");
          setIsLicenseValid(true);
        } else {
          setIsLicenseValid(true);
        }
      }
    })();

    return () => { isMounted = false };
  }, []);

//   useEffect(() => {
//   window.modelViewerLicenseReady.then(() => {
//     const valid = window.checkModelViewerLicense?.();
//     setIsLicenseValid(!!valid);
//   });
// }, []);

  // Setup event listener for SKU change
  useEffect(() => {
    const rootElement = document.getElementById(rootDiv);

    if (!rootElement) return;

    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (
          mutation.type === "attributes" &&
          mutation.attributeName === "data-product-sku"
        ) {
          const newProductSKU = rootElement.getAttribute("data-product-sku");
          if (newProductSKU && newProductSKU !== productSKU) {
            setProductSKU(newProductSKU);
            console.log("SKU changed to:", newProductSKU);
          }
        }
      }
    });

    // Start observing changes to attributes
    observer.observe(rootElement, { attributes: true });

    return () => observer.disconnect(); // Cleanup on unmount


  }, [productSKU, rootDiv]);

  // Fetch data when productSKU changes
  useEffect(() => {
    console.log('Product SKU changed to:', productSKU);
    console.log('Product settings changed to:', productSettings);
    const getData = async () => {
      const rootElement = document.getElementById(rootDiv);
      const productVariantsAttr = rootElement.getAttribute('data-product-variants');
      const productVariantsAttrTest = rootElement.getAttribute('data-product-variants-test');

      const productVariantsTestArray = '["SC-HDC-01","HF-B3S-01","HF-B3S-02"]';
      // const productVariantsTestArrayFull = `[
      //   {
      //     "sku": "WC-EBA-01",
      //     "price": "2500",
      //     "sale_price": "",
      //     "regular_price": "2500",
      //     "weight": "",
      //     "dimensions": "N/A",
      //     "attributes": {
      //       "pa_attribute_fabric": "oat"
      //     }
      //   },
      //   {
      //     "sku": "WC-EBA-02",
      //     "price": "2500",
      //     "sale_price": "",
      //     "regular_price": "2500",
      //     "weight": "",
      //     "dimensions": "N/A",
      //     "attributes": {
      //       "pa_attribute_fabric": "biscuit"
      //     }
      //   }
      // ]`;

      //TODO: Add test data for beds following implemented structure
      // const productVariantsTestArrayFull = `[
      //   {
      //     "sku":"RF-LB1-01",
      //     "price":"9.99",
      //     "sale_price":"",
      //     "regular_price":"9.99",
      //     "weight":"",
      //     "dimensions":"N\/A",
      //     "attributes":{
      //       "pa_attribute_mattress":"royale",
      //       "pa_attribute_mattress_size":"140x200",
      //       "pa_attribute_bedframe":"noFeet",
      //       "pa_attribute_bedframe_size":"140x200",
      //       "pa_attribute_bedstructure":"noFeet",
      //       "pa_attribute_bedstructure_size":"140x200",
      //       "pa_attribute_headboard":"style1",
      //       "pa_attribute_headboard_size":"225x120"
      //     }
      //   },
      //   {
      //     "sku":"RF-LB2-01",
      //     "price":"4.99",
      //     "sale_price":"",
      //     "regular_price":"4.99",
      //     "weight":"",
      //     "dimensions":"N\/A",
      //     "attributes":{
      //       "pa_attribute_mattress":"royale",
      //       "pa_attribute_mattress_size":"140x200",
      //       "pa_attribute_bedframe":"noFeet",
      //       "pa_attribute_bedframe_size":"140x200",
      //       "pa_attribute_bedstructure":"noFeet",
      //       "pa_attribute_bedstructure_size":"140x200",
      //       "pa_attribute_headboard":"style2",
      //       "pa_attribute_headboard_size":"225x120"
      //     }
      //   },
      //     {
      //     "sku":"RF-LB2-02",
      //     "price":"4.99",
      //     "sale_price":"",
      //     "regular_price":"4.99",
      //     "weight":"",
      //     "dimensions":"N\/A",
      //     "attributes":{
      //       "pa_attribute_mattress":"royale",
      //       "pa_attribute_mattress_size":"160x200",
      //       "pa_attribute_bedframe":"noFeet",
      //       "pa_attribute_bedframe_size":"160x200",
      //       "pa_attribute_bedstructure":"noFeet",
      //       "pa_attribute_bedstructure_size":"160x200",
      //       "pa_attribute_headboard":"style2",
      //       "pa_attribute_headboard_size":"225x120"
      //     }
      //   }
      // ]`;

      //Farbe is only switching the colour, nothing else. Grosse is determining the size extension of the file inside the folder
      //Style is a different folder inside Headboard => extract the 2 words to know where to look.
      //Might be easier to have everything in one folder and use a naming convention
      //e.g. Headboard_style2_Weiss_140x100. Parse attributes into a different struct, so we can then easily handle values
      //i.e. headboard: {color: white, style: style2, ...0}. Then append values with underscores to generate Headboard_style2_Weiss_140x100.
      //Pass these strings into an array to Main, we'll handle getting hold of model and setting colour there (create a new component for that)
      const productVariantsTestArrayFull = `[
        {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"0",
          "dimensions":{
            "width": "",
            "height": "",
            "depth": ""
          },
          "attributes":{
            "Matratze Größe": "140cm x 200cm", 
            "Kopfteil Größe": "140cm x 100cm", 
            "Kopfteil Farbe": "Weiß", 
            "Kopfteil Style": "style2",
            "Rahmen": "No Feet", 
            "Füße": "Metal",
            "Frame Größe": "140cm x 200cm"
            }
        },
        {
          "sku":"RFT-RM-NR2",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"140x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"140x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"140x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        },
        {
          "sku":"RFT-RM-NR3",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"160x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"160x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"160x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        },
        {
          "sku":"RFT-RM-NR4",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"0",
          "dimensions":{
            "width": "",
            "height": "",
            "depth": ""
          },
          "attributes":{
            "Matratze Größe": "140cm x 200cm", 
            "Kopfteil Größe": "140cm x 100cm", 
            "Kopfteil Farbe": "Weiß", 
            "Kopfteil Style": "style2",
            "Rahmen": "No Feet", 
            "Füße": "Metal",
            "Frame Größe": "140cm x 200cm"
            }
        },
        {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"140x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"140x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"140x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        },
          {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"160x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"160x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"160x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        },
        {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"0",
          "dimensions":{
            "width": "",
            "height": "",
            "depth": ""
          },
          "attributes":{
            "Matratze Größe": "140cm x 200cm", 
            "Kopfteil Größe": "140cm x 100cm", 
            "Kopfteil Farbe": "Weiß", 
            "Kopfteil Style": "style2",
            "Rahmen": "No Feet", 
            "Füße": "Metal",
            "Frame Größe": "140cm x 200cm"
            }
        },
        {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"140x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"140x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"140x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        },
          {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"160x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"160x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"160x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        },
        {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"0",
          "dimensions":{
            "width": "",
            "height": "",
            "depth": ""
          },
          "attributes":{
            "Matratze Größe": "140cm x 200cm", 
            "Kopfteil Größe": "140cm x 100cm", 
            "Kopfteil Farbe": "Weiß", 
            "Kopfteil Style": "style2",
            "Rahmen": "No Feet", 
            "Füße": "Metal",
            "Frame Größe": "140cm x 200cm"
            }
        },
        {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"140x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"140x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"140x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        },
          {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"160x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"160x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"160x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        },
        {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"0",
          "dimensions":{
            "width": "",
            "height": "",
            "depth": ""
          },
          "attributes":{
            "Matratze Größe": "140cm x 200cm", 
            "Kopfteil Größe": "140cm x 100cm", 
            "Kopfteil Farbe": "Weiß", 
            "Kopfteil Style": "style2",
            "Rahmen": "No Feet", 
            "Füße": "Metal",
            "Frame Größe": "140cm x 200cm"
            }
        },
        {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"140x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"140x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"140x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        },
          {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"160x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"160x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"160x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        },
        {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"0",
          "dimensions":{
            "width": "",
            "height": "",
            "depth": ""
          },
          "attributes":{
            "Matratze Größe": "140cm x 200cm", 
            "Kopfteil Größe": "140cm x 100cm", 
            "Kopfteil Farbe": "Weiß", 
            "Kopfteil Style": "style2",
            "Rahmen": "No Feet", 
            "Füße": "Metal",
            "Frame Größe": "140cm x 200cm"
            }
        },
        {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"140x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"140x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"140x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        },
          {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"160x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"160x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"160x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        },
        {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"0",
          "dimensions":{
            "width": "",
            "height": "",
            "depth": ""
          },
          "attributes":{
            "Matratze Größe": "140cm x 200cm", 
            "Kopfteil Größe": "140cm x 100cm", 
            "Kopfteil Farbe": "Weiß", 
            "Kopfteil Style": "style2",
            "Rahmen": "No Feet", 
            "Füße": "Metal",
            "Frame Größe": "140cm x 200cm"
            }
        },
        {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"140x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"140x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"140x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        },
          {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"160x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"160x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"160x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        },
        {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"0",
          "dimensions":{
            "width": "",
            "height": "",
            "depth": ""
          },
          "attributes":{
            "Matratze Größe": "140cm x 200cm", 
            "Kopfteil Größe": "140cm x 100cm", 
            "Kopfteil Farbe": "Weiß", 
            "Kopfteil Style": "style2",
            "Rahmen": "No Feet", 
            "Füße": "Metal",
            "Frame Größe": "140cm x 200cm"
            }
        },
        {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"140x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"140x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"140x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        },
          {
          "sku":"RFT-RM-NR1",
          "price":"1499",
          "sale_price":"",
          "regular_price":"1499",
          "weight":"",
          "dimensions":"N\/A",
          "attributes":{
            "pa_attribute_mattress":"royale",
            "pa_attribute_mattress_size":"160x200",
            "pa_attribute_bedframe":"noFeet",
            "pa_attribute_bedframe_size":"160x200",
            "pa_attribute_bedstructure":"noFeet",
            "pa_attribute_bedstructure_size":"160x200",
            "pa_attribute_headboard":"style2",
            "pa_attribute_headboard_size":"225x120"
          }
        }
      ]`;
      // const productVariantsTestArrayFull = `[
      //   {
      //     "sku":"RF-LB1-01",
      //     "price":"9.99",
      //     "sale_price":"",
      //     "regular_price":"9.99",
      //     "weight":"0",
      //     "dimensions":{
      //       "width": "",
      //       "height": "",
      //       "depth": ""
      //     },
      //     "attributes":{
      //       "Matratze Größe": "140cm x 200cm", 
      //       "Kopfteil Größe": "140cm x 100cm", 
      //       "Kopfteil Farbe": "Weiß", 
      //       "Kopfteil Style": "style2",
      //       "Rahmen": "No Feet", 
      //       "Füße": "Metal",
      //       "Frame Größe": "140cm x 200cm"
      //       }
      //   },
      //   {
      //     "sku":"RF-LB2-01",
      //     "price":"4.99",
      //     "sale_price":"",
      //     "regular_price":"4.99",
      //     "weight":"",
      //     "dimensions":"N\/A",
      //     "attributes":{
      //       "pa_attribute_mattress":"royale",
      //       "pa_attribute_mattress_size":"140x200",
      //       "pa_attribute_bedframe":"noFeet",
      //       "pa_attribute_bedframe_size":"140x200",
      //       "pa_attribute_bedstructure":"noFeet",
      //       "pa_attribute_bedstructure_size":"140x200",
      //       "pa_attribute_headboard":"style2",
      //       "pa_attribute_headboard_size":"225x120"
      //     }
      //   },
      //     {
      //     "sku":"RF-LB2-02",
      //     "price":"4.99",
      //     "sale_price":"",
      //     "regular_price":"4.99",
      //     "weight":"",
      //     "dimensions":"N\/A",
      //     "attributes":{
      //       "pa_attribute_mattress":"royale",
      //       "pa_attribute_mattress_size":"160x200",
      //       "pa_attribute_bedframe":"noFeet",
      //       "pa_attribute_bedframe_size":"160x200",
      //       "pa_attribute_bedstructure":"noFeet",
      //       "pa_attribute_bedstructure_size":"160x200",
      //       "pa_attribute_headboard":"style2",
      //       "pa_attribute_headboard_size":"225x120"
      //     }
      //   }
      // ]`;

      /*
      mattress_royale_140x200','bed_frame_140x200_noFeet', 'bed_structure_140x200_noFeet','headboard_225x120_style2'
      */

      //Need to get variants for configurator somehow
      //Then simply swap sku depending on variables. Find out how that works in shopify.
      //We've got an issue with product variants here => create a separate parameter and just parse the json for now
      if (rootElement.getAttribute('data-product-variants')) {
        setProductVariants(JSON.parse(rootElement.getAttribute('data-product-variants')));
      }
      else {
        setProductVariants(JSON.parse(productVariantsTestArrayFull));
        console.log('PRODUCT VARIANTS :', JSON.parse(productVariantsTestArrayFull));
      }

      if (rootElement.getAttribute('data-product-variants-test')) {
        console.log('PRODUCT VARIANTS:', rootElement.getAttribute('data-product-variants-test'));
        //Pass this down to ProductConfigurator
        setProductVariantsAttrTest(JSON.parse(rootElement.getAttribute('data-product-variants-test')));
      }
      else {
        setProductVariantsAttrTest(JSON.parse(productVariantsTestArrayFull));
      }

      if (!rootElement.getAttribute('data-customer-bucket-name')) {
        setCustomerBucketName(defaultModelViewerData.customerBucketName);
      }
      if (!rootElement.getAttribute('data-cloudfront-url')) {
        setCloudFrontUrl(defaultModelViewerData.cloudFrontUrl);
      }
      if (!rootElement.getAttribute('data-product-sku') && !productSKU) {
        setProductSKU(defaultModelViewerData.productSKU);
      }
      if (!rootElement.getAttribute('data-showproduct-buttons')) {
        setShowProductButtons(defaultModelViewerData.productSettings.showProductButtons);
      }
      if (!rootElement.getAttribute('data-product-settings')) {
        const assetsAttr = rootElement.getAttribute('data-assets-urls');

        if (assetsAttr) {
          console.log('data-assets-urls (raw string):', assetsAttr);

          // let assets = null;
          // try {
          //   assets = JSON.parse(assetsAttr);
          //   console.log('data-assets-urls (parsed):', assets);
          // } catch (e) {
          //   console.error('Failed to parse data-assets-urls JSON:', e);
          // }

          // if (assets && assets.configJson) {
          //   try {
          //     const response = await fetch(assets.configJson);
          //     const configData = await response.json();
          //     console.log('Main.js: Received config:', configData);
          //     setProductSettings(configData);
          //   } catch (error) {
          //     console.error('Main.js: Error fetching config:', error);
          //   }
          // } else {
          //   console.log('Default product settings:', defaultModelViewerData.productSettings);
          //   setProductSettings(defaultModelViewerData.productSettings);
          // }
        } else {
          console.log('No data-assets-urls found → using default product settings');
          setProductSettings(JSON.stringify(defaultModelViewerData.productSettings));
        }
      }
      if (!rootElement.getAttribute('data-dimensions-json')) {
        setDimensionsJson(defaultModelViewerData.dimensionsJson);
      }
      if (!rootElement.getAttribute('data-assets-urls')) {
        console.log('Default assets urls:', defaultModelViewerData.assetsUrls);
        setAssetsUrls(JSON.stringify(defaultModelViewerData.assetsUrls));
      }
      else {
        console.log('Assets urls:', document.getElementById(rootDiv).getAttribute('data-assets-urls'));
        console.log('Assets urls:', JSON.parse(document.getElementById(rootDiv).getAttribute('data-assets-urls')));
      }
      setLoading(false);
    };
    getData();

  }, [productSKU, productSettings]);

  useEffect(() => {
    console.log('new product folder:', productSKU);
  }, [productSKU]);

  useEffect(() => {
    if (typeof productSettings === 'string') {
      const serialisedProductSettings = JSON.parse(productSettings);
      const tempEnableConfigurator = serialisedProductSettings.enableConfigurator;
      setEnableConfigurator(tempEnableConfigurator);
    }
  })

  useEffect(() => {
    console.log('Json config file:', productSettings);
  }, [productSettings]);

  useEffect(() => {
    const handleDisplayModel = (event) => {
      const { sku, variants } = event.detail;
      // Logic to display the 3D model based on the SKU and variants
      console.log("Received SKU:", sku, "Variants:", variants);
      // Update state or call a function to render the model
    };

    window.addEventListener("displayProduct", handleDisplayModel);

    return () => {
      window.removeEventListener("displayProduct", handleDisplayModel);
    };
  }, []);

  useEffect(() => {
    // Spinner options
    const spinnerOptions = {
      lines: 12, // The number of lines to draw
      length: 0, // The length of each line
      width: 5, // The line thickness
      radius: 10, // The radius of the inner circle
      scale: 4, // Scales overall size
      corners: 1, // Corner roundness (0..1)
      color: '#000', // CSS color or array of colors
      fadeColor: 'transparent', // CSS color or array of colors
      speed: 1, // Rounds per second
      rotate: 0, // The rotation offset
      animation: 'spinner-line-fade-quick', // The CSS animation name
      direction: 1, // 1: clockwise, -1: counterclockwise
      zIndex: 2e9, // The z-index (defaults to 2000000000)
      className: 'spinner', // CSS class to assign to the spinner
      top: '50%', // Top position relative to parent
      left: '50%', // Left position relative to parent
      shadow: '0 0 1px transparent', // Box-shadow for the lines
      position: 'absolute', // Element positioning
    };

    // Create a Spinner instance
    const spinner = new Spinner(spinnerOptions);
    spinnerInstanceRef.current = spinner;

    // Mount spinner to the container
    if (spinnerContainerRef.current) {
      spinner.spin(spinnerContainerRef.current);
    }

    // Cleanup on component unmount
    return () => {
      if (spinnerInstanceRef.current) {
        spinnerInstanceRef.current.stop();
      }
    };
  }, [spinnerContainerRef.current]);

  //Add lottie file here
  if (loading) {
    return <div
      ref={spinnerContainerRef}
      className='app-loading'
      style={{ height: '250px', width: '250px' }}
    >
      {/* <Player
        autoplay
        loop
        src={`${process.env.PUBLIC_URL}/lottie_loading_pill.json`}
        style={{ height: '250px', width: '250px' }}
        onEvent={(event) => console.log("Player event:", event)}
        /> */}
    </div>;
  }

  console.log('customer bucket name: ', customerBucketName);
  console.log('cloudfront url: ', cloudFrontUrl);
  console.log('productSKU: ', productSKU);
  console.log('product tags:', productTags);
  console.log('window asset URL:', window.ASSET_BASE_URL);
  console.log('Show product buttons:', showProductButtons);

  //TODO: Delay
  return (
    !productVariants || !productSKU ? null :
      //Only pass website wide parameters in that file as we need to load variants correctly
      <>
        {enableConfigurator && <button onClick={toggleConfigurator}>Configurator</button>}
        {enableConfigurator && isConfiguratorEnabled && (
          <ProductConfigurator
            productS3BucketUrl={customerBucketName}
            productFolder={productSKU}
            cloudFrontUrl={cloudFrontUrl}
            productVariants={productVariants}
            shopDatabaseType={databaseType.wooCommerce}
            setNewSKU={setProductSKU}
            onClose={toggleConfigurator} // Close overlay
            meshClicked={meshClicked}
            isInteractive={true}
            productVariantsAttr={productVariantsAttrTest}
            setVariantFoldersNames={setVariantFoldersNames}
          />
        )}
        {/* TODO: Load model as different glbs, find best way to do it. Will have to load one model from each folder.
        Need to use the first configuration in variants as initial value/model. Leverage key, value map to go in the 
        right folder and pick the relevant model */}
        {productSKU !== "" && isLicenseValid &&
          <Suspense fallback={<div>Loading...</div>}>
            <Main
              productS3BucketUrl={customerBucketName}
              productFolder={productSKU}
              cloudFrontUrl={cloudFrontUrl}
              isAutoPlay={isAutoPlay}
              productVariants={productVariants}
              productTags={productTags}
              productSettings={productSettings}
              dimensionsJson={dimensionsJson}
              assetsUrls={assetsUrls}
              configuratorEnabled={isConfiguratorEnabled}
              showAdditionalButtons={showAdditionalButtons && showProductButtons}
              onMeshClicked={onMeshClicked}
              rootDiv={rootDiv}
            />
          </Suspense>
        }
        {!isLicenseValid &&
          <div>Invalid license</div>
        }
      </>
  );
};
export default ProductViewer;
